import { request } from '@umijs/max';

/** 获取邮箱验证码 POST /api/admin/email */
export async function sendEmailCode(
  body: API.EmailSchema,
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<any>>('/api/admin/email', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 平台用户登录 POST /api/admin/login */
export async function login(
  body: API.LoginSchema,
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<API.AdminLoginResponseSchema>>('/api/admin/login', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 平台用户退出登录 POST /api/admin/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.ResponseBaseSchema<any>>('/api/admin/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取登录用户的个人信息 GET /api/admin/myself */
export async function getMyself(options?: { [key: string]: any }) {
  return request<API.ResponseBaseSchema<API.AdminProfileSchema>>('/api/admin/myself', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 修改用户信息 PATCH /api/admin/info */
export async function updateAdminInfo(
  body: API.UserInfoUpdate,
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<any>>('/api/admin/info', {
    method: 'PATCH',
    data: body,
    ...(options || {}),
  });
}

/** 用户状态操作(启用/禁用) PATCH /api/admin/status */
export async function updateAdminStatus(
  body: API.AdminStatusSchema,
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<any>>('/api/admin/status', {
    method: 'PATCH',
    data: body,
    ...(options || {}),
  });
}

/** 获取合伙人登录跳转码 POST /api/partner/code */
export async function getPartnerCode(
  body: { partner_id: number },
  options?: { [key: string]: any },
) {
  return request<API.ResponseBaseSchema<API.PartnerCodeResponseSchema>>('/api/partner/code', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}
